// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import CreditTypeDTO from './CreditTypeDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface NewCourseChangeRequestCreditDTO extends EntitySelectorDTO { 
	id: string | null;
	newCourseChangeRequestId: string | null;
	creditTypeId: string | null;
	minHours: number | null | null;
	maxHours: number | null | null;
	displayOrder: number;
	creditType: CreditTypeDTO | null;
}

const NewCourseChangeRequestCreditDTO = {
    className: 'NewCourseChangeRequestCreditDTO',
    create: (initValues?: Partial<NewCourseChangeRequestCreditDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: '00000000-0000-0000-0000-000000000000',
			newCourseChangeRequestId: '00000000-0000-0000-0000-000000000000',
			creditTypeId: '00000000-0000-0000-0000-000000000000',
			minHours: null,
			maxHours: null,
			displayOrder: 0,
			creditType: null,
        },
        initValues);
    },
	id: 'id',
	newCourseChangeRequestId: 'newCourseChangeRequestId',
	creditTypeId: 'creditTypeId',
	minHours: 'minHours',
	maxHours: 'maxHours',
	displayOrder: 'displayOrder',
	creditType: 'creditType',
};

export default NewCourseChangeRequestCreditDTO;